import FacebookIcon from '@mui/icons-material/Facebook';
import LinkedInIcon from '@mui/icons-material/LinkedIn';
import XIcon from '@mui/icons-material/X';
import { Box, Typography } from '@mui/material';

import { styles } from './styles';

const ClientFooter: React.FC = () => {
  return (
    <Box component="footer" sx={styles.footer}>
      <Box sx={styles.footerLeft}>
        <Typography sx={styles.copyright}>© 2026 ExecutiveIQ, INC. All rights reserved.</Typography>
        <Box sx={styles.socialIcons}>
          <Box sx={styles.socialIcon}>
            <LinkedInIcon sx={{ fontSize: '12px', color: '#ffffff' }} />
          </Box>
          <Box sx={styles.socialIcon}>
            <FacebookIcon sx={{ fontSize: '12px', color: '#ffffff' }} />
          </Box>
          <Box sx={styles.socialIcon}>
            <XIcon sx={{ fontSize: '12px', color: '#ffffff' }} />
          </Box>
        </Box>
      </Box>
      <Box sx={styles.footerCenter}>
        <Typography component="a" sx={styles.footerLink}>
          Privacy Policy
        </Typography>
        <Typography component="a" sx={styles.footerLink}>
          Terms of Service
        </Typography>
        <Typography component="a" sx={styles.footerLink}>
          View Sample Profile
        </Typography>
        <Typography component="a" sx={styles.footerLink}>
          Contact Us
        </Typography>
      </Box>
    </Box>
  );
};

export { ClientFooter };
